import { InformationCircleIcon } from "@heroicons/react/24/outline";
import React from "react";

type TooltipLabelProps = {
    tooltip: string;
};

export const TooltipLabel: React.FC<TooltipLabelProps> = ({ tooltip }) => {
    return (
        <div className="inline-flex items-center space-x-1 relative group align-middle mt-[-2px]">
            <div className="relative z-20">
                <InformationCircleIcon className="w-4 h-4 text-gray-500 hover:text-gray-700 cursor-pointer align-middle" />
                <div className="absolute left-1/2 top-full mt-1 w-56 -translate-x-1/2 transform rounded-md bg-gray-800 p-2 text-sm text-white shadow-md opacity-0 group-hover:opacity-100 pointer-events-none z-50">
                    {tooltip}
                </div>
            </div>
        </div>
    );
};
